export default __webpack_public_path__ + "static/media/marauders-map-v5.2-gallery-03.760c4463.jpg";